var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-container"},[_c('img',{ref:"main",staticClass:"fill-image",attrs:{"src":_vm.getImageUrl(_vm.src),"alt":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }